import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { DigisubservicesService } from 'src/app/services/digisubservices.service';

export const _filter7 = (opt: string[], value: string): string[] => {
  const filterValue = value.toLowerCase();
  return opt.filter((item) => item.toLowerCase().includes(filterValue));
};

export const _filter8 = (opt: string[], value: string): string[] => {
  const filterValue = value.toLowerCase();
  return opt.filter((item) => item.toLowerCase().includes(filterValue));
};

export const _filter9 = (opt: string[], value: string): string[] => {
  const filterValue = value.toLowerCase();
  return opt.filter((item) => item.toLowerCase().includes(filterValue));
};

export const _filter10 = (opt: string[], value: string): string[] => {
  const filterValue = value.toLowerCase();
  return opt.filter((item) => item.toLowerCase().includes(filterValue));
};

@Component({
  selector: 'app-update-office-representative',
  templateUrl: './update-office-representative.component.html',
  styleUrls: ['./update-office-representative.component.scss'],
})
export class UpdateOfficeRepresentativeComponent implements OnInit {
  repassignform: FormGroup;
  filteredOptions6: Observable<string[]>;
  filteredOptions7: Observable<string[]>;
  filteredOptions8: Observable<string[]>;
  filteredOptions9: Observable<string[]>;
  filteredOptions10: Observable<string[]>;

  constructor(
    public fb: FormBuilder,
    public service: DigisubservicesService,
    private dialogRef: MatDialogRef<UpdateOfficeRepresentativeComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.repassignform = fb.group({
      rep: [''],
      district: [''],
      taluka: [''],
      bookstore: [''],
      subscription: [''],
      advt: [''],
      numberValue: [''],
      issue: [''],
    });
  }

  repdata;
  rep_id = 0;
  office_rep = [];
  issue_seller_name = [];
  type: string;
  book: boolean = false;
  advt: boolean = false;
  sub: boolean = false;
  issue: boolean = false;
  com_percentage: any;

  book_id = 0;
  sub_id = 0;
  advt_id = 0;
  issue_id = 0;

  ngOnInit(): void {
    this.service.getIssuesellersname().subscribe((data) => {
      this.issue_seller_name = data;
      console.log('issue_seller_name', this.issue_seller_name);
    });
    
    debugger;
    this.repdata = this.data['item'];
    this.type = this.data['type'];
    this.rep_id = this.repdata['id'];
    this.com_percentage = this.data.item['com_percentage'];

    // Log all properties to see what's available
    console.log('All repdata properties:', this.repdata);
    console.log('Type:', this.type);

    this.repassignform.get('rep').setValue(this.repdata['rep_name']);
    this.repassignform.get('district').setValue(this.repdata['district']);
    this.repassignform.get('taluka').setValue(this.repdata['taluka']);

    this.service.getOfficeRepName().subscribe((officedata) => {
      console.log('office_rep', officedata);
      this.office_rep = officedata;
      
      // After getting office rep data, set the existing ID based on name match
      this.setExistingOfficeRepId();
    });

    this.filteredOptions7 = this.repassignform
      .get('bookstore')
      .valueChanges.pipe(
        startWith(''),
        map((value) => (typeof value === 'string' ? value : value.name)),
        map((name) => (name ? this._filter7(name) : this.office_rep.slice()))
      );

    this.filteredOptions8 = this.repassignform
      .get('subscription')
      .valueChanges.pipe(
        startWith(''),
        map((value) => (typeof value === 'string' ? value : value.name)),
        map((name) => (name ? this._filter8(name) : this.office_rep.slice()))
      );

    this.filteredOptions9 = this.repassignform.get('advt').valueChanges.pipe(
      startWith(''),
      map((value) => (typeof value === 'string' ? value : value.name)),
      map((name) => (name ? this._filter9(name) : this.office_rep.slice()))
    );

    this.filteredOptions10 = this.repassignform.get('issue').valueChanges.pipe(
      startWith(''),
      map((value) => (typeof value === 'string' ? value : value.name)),
      map((name) => (name ? this._filter10(name) : this.office_rep.slice()))
    );

    this.checktype(this.type);

  }

  setExistingOfficeRepId() {
    // Find the office rep ID by matching the name
    const existingOffRepName = this.repdata['off_rep_name'];
    
    if (existingOffRepName && this.office_rep.length > 0) {
      const matchingRep = this.office_rep.find(
        (rep) => rep.name === existingOffRepName
      );
      
      if (matchingRep) {
        console.log('Found matching rep with ID:', matchingRep.id);
        
        // Set the appropriate ID based on type
        if (this.type == 'book') {
          this.book_id = matchingRep.id;
        } else if (this.type == 'issue') {
          this.issue_id = matchingRep.id;
        } else if (this.type == 'advt') {
          this.advt_id = matchingRep.id;
        } else if (this.type == 'sub') {
          this.sub_id = matchingRep.id;
        }
      } else {
        console.log('No matching rep found for name:', existingOffRepName);
      }
    }
  }

  checktype(type) {
    if (type == 'book') {
      this.repassignform
        .get('bookstore')
        .setValue(this.repdata['off_rep_name']);
      this.book = true;
    } else if (type == 'issue') {
      this.repassignform.get('issue').setValue(this.repdata['off_rep_name']);
      this.issue = true;
    } else if (type == 'advt') {
      this.repassignform.get('advt').setValue(this.repdata['off_rep_name']);
      
      // Set the number value - check multiple possible field names
      const numberValue = this.repdata['advt_number'] || 
                         this.repdata['number'] || 
                         this.repdata['advt_num'] || 
                         this.com_percentage;
      
      if (numberValue) {
        this.repassignform.get('numberValue').setValue(numberValue);
      }
      
      this.advt = true;
    } else if (type == 'sub') {
      this.repassignform
        .get('subscription')
        .setValue(this.repdata['off_rep_name']);
      this.sub = true;
    }
  }

  private _filter7(name: string): any[] {
    const filterValue = name.toLowerCase();
    return this.office_rep.filter((option) =>
      option.name.toLowerCase().includes(filterValue)
    );
  }

  private _filter8(name: string): any[] {
    const filterValue = name.toLowerCase();
    return this.office_rep.filter((option) =>
      option.name.toLowerCase().includes(filterValue)
    );
  }

  private _filter9(name: string): any[] {
    const filterValue = name.toLowerCase();
    return this.office_rep.filter((option) =>
      option.name.toLowerCase().includes(filterValue)
    );
  }

  private _filter10(name: string): any[] {
    const filterValue = name.toLowerCase();
    return this.office_rep.filter((option) =>
      option.name.toLowerCase().includes(filterValue)
    );
  }

  selected_name(event) {
    this.rep_id = event['id'];
  }

  selected_bookstore(event) {
    console.log('book id', event['id']);
    this.book_id = event['id'];
  }

  selected_subs(event) {
    console.log('sub id', event['id']);
    this.sub_id = event['id'];
  }

  selected_advt(event) {
    console.log('advt id selected:', event['id']);
    this.advt_id = event['id'];
  }

  selected_issue(event) {
    console.log('issue id', event['id']);
    this.issue_id = event['id'];
  }

  updaterep() {
    if (this.type == 'book') {
      if (this.book_id === 0) {
        window.alert('Please select an office representative for bookstore');
        return;
      }
      this.service
        .updateOfficeRep(this.rep_id, this.book_id, this.type)
        .subscribe((data) => {
          window.alert('Office Representative updated successfully...');
          this.dialogRef.close();
        });
    } else if (this.type == 'issue') {
      if (this.issue_id === 0) {
        window.alert('Please select an office representative for issue');
        return;
      }
      this.service
        .updateOfficeRep(this.rep_id, this.issue_id, 'issue')
        .subscribe((data1) => {
          window.alert('Office Representative updated successfully...');
          this.dialogRef.close();
        });
    } else if (this.type == 'advt') {
      if (this.advt_id === 0) {
        window.alert('Please select an office representative for advertisement');
        return;
      }
      
      // Get the number value from form
      let numberValue = this.repassignform.get('numberValue').value;
      
      console.log('=== UPDATE ADVT DEBUG ===');
      console.log('Raw Number Value:', numberValue);
      console.log('Number Value Type:', typeof numberValue);
      
      // Trim and convert to string first
      if (numberValue !== null && numberValue !== undefined) {
        numberValue = String(numberValue).trim();
      }
      
      console.log('After trim:', numberValue);
      console.log('Is empty?', numberValue === '');
      console.log('Length:', numberValue ? numberValue.length : 0);
      
      // Validate number value - check if it's a valid number
      if (!numberValue || numberValue === '' || isNaN(Number(numberValue))) {
        window.alert('Please enter a valid number value');
        return;
      }
      
      // Convert to number for PHP
      const numericValue = Number(numberValue);
      
      console.log('Numeric Value:', numericValue);
      console.log('Rep ID:', this.rep_id);
      console.log('Advt Office Rep ID:', this.advt_id);
      console.log('Type:', this.type);
      console.log('========================');
      
      // Make sure to pass the number as the 4th parameter
      this.service
        .updateOfficeRep(this.rep_id, this.advt_id, this.type, numericValue)
        .subscribe(
          (data) => {
            console.log('Update response:', data);
            window.alert('Office Representative and Number updated successfully...');
            this.dialogRef.close();
            window.location.reload();
          },
          (error) => {
            console.error('Update error:', error);
            window.alert('Error updating office representative: ' + (error.message || 'Unknown error'));
          }
        );
    } else if (this.type == 'sub') {
      if (this.sub_id === 0) {
        window.alert('Please select an office representative for subscription');
        return;
      }
      this.service
        .updateOfficeRep(this.rep_id, this.sub_id, this.type)
        .subscribe((data) => {
          window.alert('Office Representative updated successfully...');
          this.dialogRef.close();
        });
    }
  }
}